import { createFileRoute, redirect } from "@tanstack/react-router";

/* Hiring opens on the candidates: the people waiting on a decision, and the tab it lights. */
export const Route = createFileRoute("/_authenticated/_workforce/hiring/")({
  beforeLoad: () => {
    throw redirect({ to: "/hiring/applications", search: { stage: undefined }, replace: true });
  },
});
